const ReactDom = require("react-dom")

export function replaceHydrateFunction() {
  return (element, container, callback) => {
    console.log("replaceHydrateFunction")
    ReactDom.render(element, container, callback)
  }
}
